<div class="developer-login-view">
  <h2 class="heading">Login to Evaltrix</h2>
  <div class="sub-heading">Request a demo and stay connected with Evaltrix</div>
  <div class="login-container">
    <div class="left-section">
      {{selectedTab}}
      <mat-tab-group dynamicHeight [selectedIndex]="selectedTab">
        <mat-tab label="I HAVE AN ACCOUNT">
          <app-login [isAdminExists]="adminExists" [existingAdminEmail]="existingAdminEmail"
            (loginSubmit)="loginSumbit($event)"></app-login>
        </mat-tab>
        <mat-tab label="I WANT TO REGISTER">
          <app-register (register)="onRegister($event)"></app-register>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>
